import { IAddress } from "interfaces/address.interface";
import cls from "./addressCard.module.scss";
import NavigationFillIcon from "remixicon-react/NavigationFillIcon";
import { useTranslation } from "react-i18next";
import More2FillIcon from "remixicon-react/More2FillIcon";
import PopoverContainer from "containers/popover/popover";
import EditLineIcon from "remixicon-react/EditLineIcon";
import DeleteBinLineIcon from "remixicon-react/DeleteBinLineIcon";
import usePopover from "hooks/usePopover";

type Props = {
  data: IAddress;
  changeAddress: (item: IAddress) => void;
  onEdit: (item: IAddress) => void;
  onDelete: (id: number) => void;
  isSelected?: boolean;
};

export default function AddressCard({
  data,
  changeAddress,
  onEdit,
  onDelete,
  isSelected = false,
}: Props) {
  const { t } = useTranslation();
  const [open, anchor, handleOpen, handleClose] = usePopover();
  return (
    <div
      className={`${cls.container} ${isSelected && cls.selected}`}
      onClick={() => {
        changeAddress(data);
      }}
    >
      <div className={cls.body}>
        <div className={cls.icon}>
          <NavigationFillIcon size={20} />
        </div>
        <div>
          <h3 className={cls.title}>{data?.title || t("title")}</h3>
          <p className={cls.description}>{data?.address?.address || ""}</p>
        </div>
      </div>
      <button
        type="button"
        className={cls.moreOptionsButton}
        onClick={(e) => {
          e.stopPropagation();
          handleOpen(e);
        }}
      >
        <More2FillIcon size={20} />
      </button>
      <PopoverContainer
        open={open}
        anchorEl={anchor}
        onClose={(e) => {
          // @ts-ignore
          e.stopPropagation();
          handleClose();
        }}
        anchorOrigin={{
          vertical: 30,
          horizontal: -55,
        }}
        customStyles={{
          borderRadius: "10px",
        }}
      >
        <div className={cls.popoverContainer}>
          <button
            type="button"
            className={cls.item}
            onClick={(e) => {
              e.stopPropagation();
              onEdit(data);
              handleClose();
            }}
          >
            <EditLineIcon size={16} />
            <span>{t("edit")}</span>
          </button>
          {!isSelected && (
            <button
              type="button"
              className={cls.item}
              onClick={(e) => {
                e.stopPropagation();
                if (data?.id) {
                  onDelete(data?.id);
                }
              }}
            >
              <DeleteBinLineIcon size={16} />
              <span>{t("delete")}</span>
            </button>
          )}
        </div>
      </PopoverContainer>
    </div>
  );
}
